import { useNavigate } from 'react-router-dom';
import { RoutesPaths } from 'routes/Routes.types';
import { Button, useTranslation } from '@packages/utils';
import EmptyBox from 'assets/images/EmptyBox.svg';
import { Image } from 'components/Base/Image';
import { Paragraph } from 'components/Base/Typography';
import { Row, Col } from 'components/Base/Grid';

const ExpiredEventLinkView = () => {
  const navigate = useNavigate();
  const { t } = useTranslation({
    keyPrefix: 'descriptions.event-landing.event-detail.expired-event',
  });

  return (
    <Row justify="center" className="text-center py-10">
      <Col span={24}>
        <Image src={EmptyBox} alt="Empty box" width={137} height={139} />
        <Paragraph className="mt-2">{t('TITLE')}</Paragraph>
        <Row justify="center">
          <Button
            type="primary"
            color="primary"
            onClick={() => navigate(`/${RoutesPaths.EVENTS}`)}
          >
            {t('BACK_TO_EVENTS_BTN')}
          </Button>
        </Row>
      </Col>
    </Row>
  );
};

export default ExpiredEventLinkView;
